// extracted by mini-css-extract-plugin
export default {"formItem":"Select_formItem__9T0Nb"};